import * as React from "react";
const SvgFiRrMatchFire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-match-fire_svg__a)">
      <path
        fill="#062147"
        d="M23.855 10.012a1 1 0 0 0-1.373-.337l-12.125 7.341c-1.315.018-4.485.13-5.639.764a3.3 3.3 0 0 0-1.586 1.98 3.3 3.3 0 0 0 .279 2.522 3.3 3.3 0 0 0 1.979 1.586q.462.134.93.133c.551 0 1.096-.139 1.592-.412 1.198-.658 2.84-3.629 3.488-4.868l12.118-7.336a1 1 0 0 0 .338-1.374zM6.948 21.837a1.3 1.3 0 0 1-.999.11 1.3 1.3 0 0 1-.786-.629 1.3 1.3 0 0 1-.11-1c.098-.337.321-.617.63-.786.397-.219 1.774-.384 3.244-.465-.821 1.415-1.636 2.575-1.979 2.77m.727-5.94c2.277-.4 4.233-2.107 4.982-4.346 1.429-4.264-1.906-7.55-4.112-9.724l-.344-.339a1.828 1.828 0 0 0-2.987.626c-.293.747-.45 1.522-.589 2.206-.149.741-.267 1.23-.396 1.48a6 6 0 0 1-.27-.759 1.44 1.44 0 0 0-1.196-1.027 1.46 1.46 0 0 0-1.439.672C.507 5.987.001 8.198.001 9.5a6.49 6.49 0 0 0 2.323 4.981A6.5 6.5 0 0 0 6.513 16q.58 0 1.162-.102M3.61 12.95A4.5 4.5 0 0 1 2.001 9.5c0-.685.202-1.747.514-2.646C2.846 7.5 3.309 8 4.001 8c1.921 0 2.305-1.898 2.586-3.284.109-.543.223-1.102.397-1.62l.157.155c2.073 2.042 4.652 4.583 3.62 7.664-.52 1.554-1.867 2.735-3.434 3.011-1.355.24-2.68-.107-3.718-.978zm1.393.35c-.693-.81-.558-2.047.195-2.8l.739-.74a.83.83 0 0 1 1.176 0l.739.74c.753.754.888 1.99.195 2.8a2.002 2.002 0 0 1-3.045 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-match-fire_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMatchFire;
